/**
 * SUN-283 review — a product's price and GST % as line numbers.
 * The products API sends Prisma Decimals as text ("1180", "18"); left as text, `100 + "18"` became
 * "10018" in the inclusive maths (Sales Order showed ₹13.90). 0 is a real rate and stays 0; a missing
 * or unreadable GST % stays null so the line shows 'Select' — never a guessed 18.
 */
export function productRateAndGst(p: { unitPrice?: unknown; gstRate?: unknown }): { rate: number; gstRate: number | null } {
  const rate = Number(p.unitPrice ?? 0) || 0;
  const g = p.gstRate;
  const n = g == null || g === '' ? NaN : Number(g);
  return { rate, gstRate: Number.isFinite(n) ? n : null };
}
